import { defineComponent as _defineComponent } from 'vue'
import Button from '@/components/buttons/Button.vue';
import InputGroup from '@/components/form/InputGroup.vue';
import Checkbox from '@/components/inputs/Checkbox.vue';
import SelectInput from '@/components/inputs/SelectInput.vue';
import TextInput from '@/components/inputs/TextInput.vue';
import TimePicker from '@/components/inputs/TimePicker.vue';
import i18n from '@/i18n';
import { Icon } from '@/lib/enum/Icon';
import { breakInsideShiftTimeRange } from '@/lib/forms/customValidators/shiftSessionsValidators';
import {
  getErrorMessages,
  integer,
  minValue,
  required,
  timeFormat as timeFormatValidator,
} from '@/plugins/vuelidate';
import store from '@/store';
import { ScheduledBreakFormItemType } from '@/types/shiftSessionsForm';
import { viewport } from '@/util/windowFunctions';
import { useVuelidate } from '@vuelidate/core';
import { computed, onMounted, reactive, watch } from 'vue';
import { CompanySettingTimeFormatEnum } from '../../../api/v1';

/* PROPS */

export default /*#__PURE__*/_defineComponent({
  __name: 'BreakDetailsItem',
  props: {
    shiftStartTime: null,
    shiftEndTime: null,
    scheduledBreak: null,
    showDelete: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false }
  },
  emits: ["input", "removeBreak"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: ScheduledBreakFormItemType): void;
  (e: 'removeBreak', value: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { shiftStartTime: string, shiftEndTime: string, scheduledBreak: ScheduledBreakFormItemType, showDelete: boolean, disabled: boolean }



/* EMITS */


/* DATA */
const form = reactive<ScheduledBreakFormItemType>({ ...props.scheduledBreak });

const timeFormat = computed<CompanySettingTimeFormatEnum>(
  () => store.getters['settings/timeFormat'],
);
const validations = computed(() => ({
  paid: {},
  durationInMinutes: {
    required,
    integer,
    minValue: minValue(1),
  },
  breakStartTimeEnabled: {},
  startTime: form.breakStartTimeEnabled
    ? {
        required,
        timeFormat: timeFormatValidator(timeFormat.value),
        breakInsideShiftTimeRange: breakInsideShiftTimeRange(
          () => props.shiftStartTime,
          () => props.shiftEndTime,
        ),
      }
    : {},
}));

const v$ = useVuelidate(validations, form, { $autoDirty: true });

/* COMPUTED */
const unpaidBreakName = computed<string | null>(
  () => store.state.settings.scheduleSettings.unpaidBreakName,
);
const paidBreakName = computed<string | null>(
  () => store.state.settings.scheduleSettings.paidBreakName,
);

const breakPaidList = computed<{ paid: boolean; name: string }[]>(() => [
  {
    paid: false,
    name: unpaidBreakName.value ?? i18n.tc('label.unpaidBreak'),
  },
  {
    paid: true,
    name: paidBreakName.value ?? i18n.tc('label.paidBreak'),
  },
]);

/* METHODS */
const validateBreakTime = (val: string): boolean => {
  v$.value.durationInMinutes.$touch();
  if (v$.value.durationInMinutes.$errors.length) return;
  form.durationInMinutes = Number(val);
};

const setBreakStartTimeEnabled = (v: boolean) => {
  form.breakStartTimeEnabled = v;
  if (!v) {
    form.startTime = '';
  }
};

/* WATCH */
watch(form, (v) => {
  emit('input', v);
});

onMounted(() => {
  // touch the form on mounted so that any default '0' duration breaks show an error message
  if (form.durationInMinutes === 0) {
    v$.value.$touch();
  }
});

return { __sfc: true,props, emit, form, timeFormat, validations, v$, unpaidBreakName, paidBreakName, breakPaidList, validateBreakTime, setBreakStartTimeEnabled, Button, InputGroup, Checkbox, SelectInput, TextInput, TimePicker, Icon, getErrorMessages, viewport, CompanySettingTimeFormatEnum }
}

})